<template>
  <div v-if="timeLeft > 0">
    <span class="time"> {{ formattedTime }}</span>
  </div>
</template>

<script setup>
  import { ref, computed, onBeforeUnmount, watch } from "vue";

  const props = defineProps({
    // 传入的总秒数
    seconds: {
      type: Number,
      required: true
    }
  });

  const timeLeft = ref(props.seconds);
  let timer = null;

  // 倒计时格式化显示
  const formattedTime = computed(() => {
    const s = timeLeft.value;

    const days = Math.floor(s / 86400);
    const hours = Math.floor((s % 86400) / 3600);
    const minutes = Math.floor((s % 3600) / 60);
    const seconds = s % 60;

    const hStr = String(hours).padStart(2, "0");
    const mStr = String(minutes).padStart(2, "0");
    const sStr = String(seconds).padStart(2, "0");

    if (s >= 86400) {
      return `${days}天${hStr}时${mStr}分${sStr}秒`;
    } else {
      return `${hStr}时${mStr}分${sStr}秒`;
    }
  });

  const startCountdown = () => {
    timer = setInterval(() => {
      if (timeLeft.value > 0) {
        timeLeft.value--;
      } else {
        clearInterval(timer);
      }
    }, 1000);
  };

  onBeforeUnmount(() => {
    if (timer) clearInterval(timer);
  });
  watch(
    () => props.seconds,
    (newVal) => {
      if (newVal) {
        timeLeft.value = newVal;
        startCountdown();
      }
    },
    { immediate: true }
  );
</script>

<style lang="scss" scoped>
  .time {
    font-size: 16px;
    color: #fff;
  }
</style>
